/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceArticleTreatment } from '../../models/service-article-treatment';

export interface GetServiceArticleTreatment$Params {
}

export function getServiceArticleTreatment(http: HttpClient, rootUrl: string, params?: GetServiceArticleTreatment$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceArticleTreatment>> {
  const rb = new RequestBuilder(rootUrl, getServiceArticleTreatment.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ServiceArticleTreatment>;
    })
  );
}

getServiceArticleTreatment.PATH = '/api/service-article-treatment';
